<template>
  <div class="filter-daterange">
    <input-select-nt :fieldData="fieldData"></input-select-nt>
  </div>
</template>

<script>
import InputSelectNt from '../InputSelectNt';

export default {
  inject: ['$validator'], // Allows this component's validation messages to appear in other components
  props: {
    fieldData: {
      field_value: '', // TODO: Use config values
    },
  },
  created() {
    this.fieldData.values = this.fieldData.values.filter(v => v.internal_value !== this.fieldData.field_value);
    this.fieldData.field_value = '';
  },
  components: {
    InputSelectNt,
  },
  watch: {
    // Updates chart when chart type changes (API request)
    'fieldData.field_value': () => {
      // window.console.info('dimension (fieldData) changed.', newValue);
    },
  },
};
</script>

<style scoped>



// WEBPACK FOOTER //
// src/components/interactive/widgets/FilterDimension.vue?483d42b7